const candidateActions = {
    GET_FULL_CANDIDATE_DETAILS: 'GET_FULL_CANDIDATE_DETAILS',
    SET_FULL_CANDIDATE_DETAILS: 'SET_FULL_CANDIDATE_DETAILS',

    GET_SCRIBE1_PHOTO_DETAILS:"GET_SCRIBE1_PHOTO_DETAILS",
    SET_SCRIBE1_PHOTO_DETAILS:"SET_SCRIBE1_PHOTO_DETAILS",

        GET_FULL_SCRIBE_CANDIDATE_DETAILS: 'GET_FULL_SCRIBE_CANDIDATE_DETAILS',
    SET_FULL_SCRIBE_CANDIDATE_DETAILS: 'SET_FULL_SCRIBE_CANDIDATE_DETAILS',

    GET_TICKETS_LIST_BY_CANDIDATE: 'GET_TICKETS_LIST_BY_CANDIDATE',
    SET_TICKETS_LIST_BY_CANDIDATE: 'SET_TICKETS_LIST_BY_CANDIDATE',

    GET_UPLOAD_PERSONAL_DETAILS : 'GET_UPLOAD_PERSONAL_DETAILS',
    SET_UPLOAD_PERSONAL_DETAILS : 'SET_UPLOAD_PERSONAL_DETAILS',
    GET_SEARCH_CANDIDATE_DETAILS : 'GET_SEARCH_CANDIDATE_DETAILS',
    SET_SEARCH_CANDIDATE_DETAILS : 'SET_SEARCH_CANDIDATE_DETAILS',
    SET_UPDATE_CANDIDATE_DETAILS : 'SET_UPDATE_CANDIDATE_DETAILS',
    SET_UPDATE_CANDIDATE_DETAILS : 'SET_UPDATE_CANDIDATE_DETAILS',
    CHECK_DUPLICATE_EMAIL_OR_MOBILENO: 'CHECK_DUPLICATE_EMAIL_OR_MOBILENO',
    GET_PROFILE_PERSONAL_DETAILS : 'GET_PROFILE_PERSONAL_DETAILS',
    SET_PROFILE_PERSONAL_DETAILS : 'SET_PROFILE_PERSONAL_DETAILS',
    UPDATE_CANDIDATE_DETAILS : 'UPDATE_CANDIDATE_DETAILS',
    GET_COURSE_NAME_FOR_DUMP:"GET_COURSE_NAME_FOR_DUMP",
    SET_COURSE_NAME_FOR_DUMP:"SET_COURSE_NAME_FOR_DUMP",

  GENERATE_DUMP_REQUEST: "GENERATE_DUMP_REQUEST",
  GENERATE_DUMP_SUCCESS: "GENERATE_DUMP_SUCCESS",
  GENERATE_DUMP_FAILURE: "GENERATE_DUMP_FAILURE",
  GET_DOWNLOAD_DUMP_URL:"GET_DOWNLOAD_DUMP_URL",
  SET_DOWNLOAD_DUMP_URL:"SET_DOWNLOAD_DUMP_URL",
  GENERATE_DUMP_RETRY:"GENERATE_DUMP_RETRY",
  GET_PENDING_DUMP:"GET_PENDING_DUMP",
  SET_PENDING_DUMP:"SET_PENDING_DUMP",
  RE_GENERATE_DUMP_REQUEST:"RE_GENERATE_DUMP_REQUEST",
  RE_GENERATE_DUMP_FAILURE:"RE_GENERATE_DUMP_FAILURE",
  RE_GENERATE_DUMP_SUCCESS:"RE_GENERATE_DUMP_SUCCESS",
  OPEN_DUMP_EMAIL_PROMPT:"OPEN_DUMP_EMAIL_PROMPT",
  CLEAR_DUMP_EMAIL_PROMPT:"CLEAR_DUMP_EMAIL_PROMPT"
}

export default candidateActions;